import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { environment } from '../../../../environments/environment.development';

@Injectable({
  providedIn: 'root'
})
export class QuotesService {
  private _http = inject(HttpClient);
  private _baseUrl = `${environment.apiUrl}/administrative`;

  approveQuote(quoteId: string, data: {
    signature: File;
    name: string;
    job_position: string;
    comments: string;
  }): Observable<any> {
    const formData = new FormData();

    formData.append('signature', data.signature);
    formData.append('name', data.name);
    formData.append('job_position', data.job_position);
    formData.append('comments', data.comments);

    return this._http.patch<any>(
      `${this._baseUrl}/quotes_signature/${quoteId}/approved/`,
      formData
    );
  }
}
